import React from "react";
import "./styles.css";
import { Button } from "../common/Button";
// import Drag from "../../svg/Drag";
import { setDragData } from "../../entities/actions";
import { useDispatch, useSelector } from "react-redux";
// import { OrderWithInfo } from "../common/Order/ProgressOrder/orderWithInfo.jsx";
import { TimeTableGrid } from "./TimeTableGrid";
import { PrevIcon, NextIcon, PauseIcon, PlayIcon } from "../../svg/Nav";
import { config } from "../../config";

export const Timetable = ({
  chartArray,
  simulationSpeed,
  chartDots,
  simulation,
  start,
  steps,
  currentTick,
  randomize,
  stepBack,
  stepForward,
  startStop,
  maxMin,
  activeOrders,
  rewindMouseDown,
  rewindMouseLeave,
  rewindMouseUp,
  jumpToEnd,
  jumpToStart,
  resetSimulation,
  simulator
}) => {
  const orders = useSelector(state => state.init.orders);
  const limits = useSelector(state => state.init.limits);
  const dispatch = useDispatch();
  const onDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const onDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    if (
      e.nativeEvent.path?.find(el => el.classList.contains("orders-choose"))
        .id === "baseplate"
    ) {
      dispatch(setDragData({ isDrag: false, offsetX: null }));
    }
  };

  const isReadyToSimulation = orders => {
    const activeOrders = orders.filter(e => e.x);
    return (
      activeOrders.length >= 2 &&
      activeOrders.some(e => e.side === "BUY") &&
      activeOrders.some(e => e.side === "SELL")
    );
  };

  const subtract = (a, b) => {
    return +(a - b);
  };

  let volumeCount = 0;
  for (let i = 1; i <= currentTick; i++) {
    volumeCount = volumeCount + chartArray[i]?.quantity;
  }

  const changeValue = subtract(
    chartArray[currentTick]?.price,
    chartArray[0]?.price
  )

  return (
    <div className="timetable-wrapper">
      <div
        id="baseplate"
        className="orders-choose"
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        <div className="limits-wrapper">
          <div className="upper-limit">{limits?.upper.toFixed(2)}</div>
          <div className="upper-limit">
            {limits?.upper &&
              limits?.lower &&
              ((limits?.upper + limits?.lower) / 2).toFixed(2)}
          </div>
          <div className="lower-limit">{limits?.lower.toFixed(2)}</div>
        </div>
      </div>

      <div className="timetable-divider"></div>
      <div className="timetable">
        <div className="timetable-header">
          <span className="title">{config.priceChart.title}</span>
          <div className="controls-header">
            <div className="trade-info">
              {chartArray.length ? (
                <>
                  <div>{`${config.priceChart.lastSale}: $${chartArray[currentTick]?.price.toFixed(4)}`}</div>
                  <div>
                    {`${config.priceChart.change}: `}
                    <span style={{ color: changeValue >= 0 ? "#00DE82" : "#FF3038" }}>
                      {`$${Math.abs(changeValue).toFixed(4)}`}
                    </span>
                  </div>
                  <div>{`${config.priceChart.volume}: ${volumeCount}`}</div>
                </>
              ) : (
                ""
              )}
            </div>
            <div>
              {simulation ? (
                <div className="drag-caption">
                  <Button
                    icon={{
                      src: config.priceChart.replay,
                      position: "left",
                      color: "dark"
                    }}
                    inactive={start}
                    onClick={jumpToStart}
                    className="control-button icon-button"
                  >
                    {config.priceChart.replay}
                  </Button>
                  <Button
                    icon={{ src: PrevIcon, position: "left", color: "dark" }}
                    inactive={start}
                    onMouseDown={() => rewindMouseDown("back")}
                    onMouseUp={() => rewindMouseUp("back")}
                    onMouseLeave={() => rewindMouseLeave("back")}
                    className="control-button icon-button"
                  >
                    {config.priceChart.stepBack}
                  </Button>
                  <Button
                    icon={
                      start
                        ? { src: PauseIcon, position: "left" }
                        : { src: PlayIcon, position: "left" }
                    }
                    onClick={startStop}
                    className="control-button play-pause icon-button"
                  >
                    {start ? config.priceChart.pause : config.priceChart.play}
                  </Button>
                  <Button
                    icon={{ src: NextIcon, position: "right", color: "dark" }}
                    inactive={start}
                    onMouseDown={() => rewindMouseDown("forward")}
                    onMouseUp={() => rewindMouseUp("forward")}
                    onMouseLeave={() => rewindMouseLeave("forward")}
                    className="control-button icon-button"
                  >
                    {config.priceChart.stepForward}
                  </Button>
                  <Button
                    icon={{ src: NextIcon, position: "right", color: "dark" }}
                    inactive={start}
                    onClick={() => resetSimulation(simulator)}
                    className="control-button icon-button"
                  >
                    {config.priceChart.reset}
                  </Button>
                </div>
              ) : (
                <div className="drag-caption">
                  <Button
                    text={
                      isReadyToSimulation(orders) ? "Start" : "Randomize orders"
                    }
                    className="timetable-randomize-button"
                    onClick={
                      isReadyToSimulation(orders) ? startStop : randomize
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <TimeTableGrid
          chartArray={chartArray}
          steps={steps}
          simulationSpeed={simulationSpeed}
          chartDots={chartDots}
          simulation={simulation}
          currentTick={currentTick}
          activeOrders={activeOrders}
        />
      </div>
    </div>
  );
};
